import { render, staticRenderFns } from "./TestTagModal.vue?vue&type=template&id=659f2646&"
import script from "./TestTagModal.vue?vue&type=script&lang=js&"
export * from "./TestTagModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports